// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './AdminPanelStockForm.styles';
import AdminPanelStockFormControls from './AdminPanelStockFormControls';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import axios from 'axios';
import { updateData, initialData } from '../../../api/common/actions';
import { readSettings } from '../../../helpers/board';

export class AdminPanelStockForm extends Component {
  handleBack = () => {
    this.props.history.push('/RearStock/AdminPanel');
  };

  onDataSourceChange = () => {
    this.getBoxesData();
  };

  getBoxesData = () => {
    let boxId;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      boxId = fileData ? fileData.boxId : '';
    } else {
      boxId = localStorage.getItem('boxId');
    }
    if (boxId) {
      return axios
        .get(process.env.REACT_APP_BASEURL + 'getprescriptions/' + boxId)
        .then(response => {
          this.props.updateData(response.data);
          return response.data;
        });
    } else {
      return axios.get(
        process.env.REACT_APP_BASEURL + 'getprescriptions/' + null
      );
    }
  };

  render() {
    const { classes, box } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <div className={classNames(classes.form)}>
          <AdminPanelStockFormControls
            onDataSourceChange={this.onDataSourceChange}
            handleBack={this.handleBack}
            box={box}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateData: box => dispatch(updateData(box)),
  initialData: box => dispatch(initialData(box))
});

export default connect(
  null,
  mapDispatchToProps
)(
  withStyles(styles, { withTheme: true })(
    injectIntl(withRouter(AdminPanelStockForm))
  )
);
